import React from 'react';
import { connect } from 'react-redux';
import './style.less';

function Description({ intro_text, description }) {
  const textLength = intro_text.length + description.length;
  let descriptionClassName = 'columns3';
  if (textLength < 1000) descriptionClassName = 'columns1';
  else if (textLength < 2000) descriptionClassName = 'columns2';

  // show intro text only if it exists -
  // the problem is it always has the <p> tags in, thats why we check
  // for min length of 10
  return (
    <div className={`${descriptionClassName} description`}>
      {intro_text.length > 10 && (
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: intro_text }}
          className="text intro"
        />
      )}
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: description }} className="text" />
    </div>
  );
}

const mapStateToProps = ({ app }) => {
  return {
    intro_text: app.data.intro_text,
    description: app.data.description,
    title: app.data.title
  };
};

export default connect(mapStateToProps)(Description);
